interface TablePinIconProps {
  isPinned?: boolean;
}

export default function TablePinIcon({ isPinned = false }: TablePinIconProps) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      {isPinned ? (
        <path
          d="M18 13.61C18 13.02 17.83 12.44 17.5 11.95L16.17 9.96C16.06 9.78 16 9.59 16 9.39V5H17V3H7V5H8V9.39C8 9.59 7.94 9.78 7.83 9.94L6.5 11.94C6.17 12.44 6 13.01 6 13.61V17H11V22H13V17H18V13.61Z"
          fill="currentColor"
        />
      ) : (
        <path
          d="M14 4V9C14 10.12 14.37 11.16 15 12H9C9.63 11.16 10 10.12 10 9V4H14ZM17 2H7C6.45 2 6 2.45 6 3C6 3.55 6.45 4 7 4H8V9C8 10.66 6.66 12 5 12V14H10.97V21L11.97 22L12.97 21V14H19V12C17.34 12 16 10.66 16 9V4H17C17.55 4 18 3.55 18 3C18 2.45 17.55 2 17 2Z"
          fill="currentColor"
          transform="rotate(45 12 12)"
        />
      )}
    </svg>
  );
}
